import { useTranslation } from 'react-i18next'
import classnames from 'classnames'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { useMenuCollapsedState } from '../../../hooks'
import Button, { BUTTON_HEIGHT_40 } from '../../Button'

import * as styles from './LayoutHeaderMenuToggle.module.css'

import SwitcherIcon from '../../../icons/switcher-right.svg'

function LayoutHeaderMenuToggle({
  className = styles.LayoutHeaderMenuToggle,
  ...buttonProps
}) {
  const [collapsed, setCollapsed] = useMenuCollapsedState()

  const { t } = useTranslation()

  function handleClick() {
    setCollapsed(currCollapsed => !currCollapsed)
  }

  const buttonClassName = classnames(className, {
    [styles.collapsed]: collapsed,
  })

  const tooltip = collapsed
    ? 'Header.ExpandMenuBtnKey'
    : 'Header.CollapseMenuBtnKey'

  return (
    <Button.Flat
      {...buttonProps}
      isGrey
      beforeIconProps={{ Icon: SwitcherIcon }}
      className={buttonClassName}
      height={BUTTON_HEIGHT_40}
      tooltip={t(tooltip)}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.bottom}
      onClick={handleClick}
    />
  )
}

export default LayoutHeaderMenuToggle
